module.exports = __webpack_public_path__ + "img/icon-loader-maxima1.f60647bc.svg";